import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { LightbulbIcon, XIcon } from 'lucide-react';
const tips = [['Class planning tip', 'Use a ready-to-teach structure, then personalize it for your room.'], ['Choreography tip', 'Layer one movement at a time so every level can join in.'], ['Instructor tip', 'Clear cueing helps students feel capable before the next combination begins.'], ['Planning tip', 'A themed class can give your week a fresh energy and a clear focus.']];
export function PurchaseNotifications() {
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const [index, setIndex] = useState(0);
  useEffect(() => {
    if (dismissed) return;
    let currentTimer: number;
    const schedule = (delay: number) => {
      currentTimer = window.setTimeout(() => {
        setVisible(true);
        currentTimer = window.setTimeout(() => {
          setVisible(false);
          currentTimer = window.setTimeout(() => {
            setIndex(current => (current + 1) % tips.length);
            schedule(0);
          }, 500);
        }, 5000);
      }, delay);
    };
    schedule(3000);
    return () => window.clearTimeout(currentTimer);
  }, [dismissed]);
  const [title, description] = tips[index];
  return <div aria-live="polite" className="pointer-events-none fixed inset-x-0 bottom-4 z-50 flex justify-center px-4" data-id="element-191">
      <AnimatePresence data-id="element-192">
        {visible && <motion.aside initial={{
        opacity: 0,
        y: 24
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: 18
      }} transition={{
        type: 'spring',
        damping: 24,
        stiffness: 280
      }} className="pointer-events-auto relative flex w-full max-w-sm gap-3 rounded-xl border border-navy/20 bg-white p-3.5 shadow-xl" data-id="element-193">
            <span className="flex size-10 shrink-0 items-center justify-center rounded-full bg-orange text-white" data-id="element-194">
              <LightbulbIcon size={18} data-id="element-195" />
            </span>
            <div className="min-w-0 pr-4" data-id="element-196">
              <p className="text-[11px] font-semibold text-navy" data-id="element-197">{title}</p>
              <p className="mt-0.5 text-sm leading-snug text-slate-600" data-id="element-198">
                {description}
              </p>
            </div>
            <button type="button" onClick={() => {
          setDismissed(true);
          setVisible(false);
        }} className="absolute right-2 top-2 rounded p-1 text-slate-400 hover:text-navy focus:outline-none focus-visible:ring-2 focus-visible:ring-orange" aria-label="Dismiss planning tip" data-id="element-199">
              <XIcon size={14} data-id="element-200" />
            </button>
          </motion.aside>}
      </AnimatePresence>
    </div>;
}